<template>
  <button
      type="button"
      class="approve-button"
      :disabled="disabled"
      @click="$emit('click')">
    <i class="fa-solid fa-circle-check approve-button-icon"></i>
    <span class="approve-button-text">{{ label }}</span>
  </button>
</template>

<script setup>
import {computed, defineEmits, defineProps} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

defineProps({
  label: {
    type: String,
    default: 'Genehmigen'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
.approve-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid v-bind(companyColor);
  color: v-bind(companyColor);
  background-color: transparent;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.approve-button:hover:not(:disabled) {
  color: #ffffff;
  background-color: v-bind(companyColor);
}

.approve-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.approve-button-icon {
  font-size: 12px;
}

.approve-button-text {
  white-space: nowrap;
}
</style>
